import * as yup from 'yup';

export enum SupportCaseIssueType {
	ACCOUNT_MANAGEMENT = 'ACCOUNT_MANAGEMENT',
	APP_ISSUES = 'APP_ISSUES',
	PROGRAM_MATERIALS = 'PROGRAM_MATERIALS',
	COLLECTION_RELATED = 'COLLECTION_RELATED',
	COMMUNITY_PARTICIPATION = 'COMMUNITY_PARTICIPATION',
	BUSINESS_OR_CORPORATE = 'BUSINESS_OR_CORPORATE',
	FEEDBACK = 'FEEDBACK',
	GENERAL_OR_OTHER_INQUIRIES = 'GENERAL_OR_OTHER_INQUIRIES',
}

export const issueTypeLabels: Record<SupportCaseIssueType, string> = {
	ACCOUNT_MANAGEMENT: 'Account Management',
	APP_ISSUES: 'App Issues',
	PROGRAM_MATERIALS: 'Program Materials',
	COLLECTION_RELATED: 'Collection Related',
	COMMUNITY_PARTICIPATION: 'Community Participation',
	BUSINESS_OR_CORPORATE: 'Business or Corporate',
	FEEDBACK: 'Feedback',
	GENERAL_OR_OTHER_INQUIRIES: 'General or other inquiries',
};

export const issueTypeOptions = Object.entries(issueTypeLabels).map(([value, label]) => ({
	label,
	value,
}));

export type ReportIssueFormValues = {
	typeOfIssue?: SupportCaseIssueType;
	comments: string;
	code: string;
};

export const validationSchema = yup.object({
	typeOfIssue: yup.string().required(),
	comments: yup.string().required(),
});
